import { api } from "@/redux/api";

import {
	NotificationResponse,
	NotificationResponseSchema,
	NotificationQueryParams,
	UnreadCount,
	UnreadCountSchema,
} from "../../pages/Notifications/schema/notification";

export const notificationApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getNotifications: builder.query<NotificationResponse, NotificationQueryParams>({
			query: (params) => ({
				url: "notifications",
				params: {
					...(params && { ...params }),
				},
				responseSchema: NotificationResponseSchema,
			}),
			providesTags: ["Notifications"],
		}),
		getUnreadCount: builder.query<UnreadCount, void>({
			query: () => ({
				url: "notifications/unread-count",
				responseSchema: UnreadCountSchema,
			}),
			providesTags: ["Notifications"],
		}),
		markAsRead: builder.mutation<{ success: boolean }, number>({
			query: (id) => ({
				url: `notifications/${id}/read`,
				method: "PATCH",
			}),
			invalidatesTags: ["Notifications"],
		}),
		markAllAsRead: builder.mutation<{ success: boolean; count: number }, void>({
			query: () => ({
				url: "notifications/read-all",
				method: "PATCH",
			}),
			invalidatesTags: ["Notifications"],
		}),
	}),
});

export const {
	useGetNotificationsQuery,
	useGetUnreadCountQuery,
	useMarkAsReadMutation,
	useMarkAllAsReadMutation,
} = notificationApi;
